
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABvUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/2qb/4+0/5u8/2mb/0WC/83e/////8DV/8DW/8HV /83d/9rm/5y9//L3/5C0/7TN/460/wAAAJM8Tr8AAAASdFJOUwBAj9/PnyAQkI/PQM/PjxDfP5Lb pTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzkiVKWJywAA ALpJREFUKM+VkusOgyAMRjsUL3ObWwUBd3P6/u84VFRmyhLPHygnJTR8AJYDi/CHmCcwkWZIkKej i5HkONgMA+QACQYpgIclg5NXVULWXhnBulfaWBq1nnjybkY0JSvjqAkpZykIKWYp916LenIN+Vr1 GNyTHgXxZZ1fL/KttW6Nae0itvJjPORGal8+98jOl90sXbRULxd6N80ZLuHP5lCEpY1nsJXZ9JX/ ogkl2ctSl/mEb7qv7DacfwHhojdfOEhDVQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQw MjozMjowOSswMDowMJjV/CYAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MDkr MDA6MDDpiESaAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAw gs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    